import { Dispatch, FC, SetStateAction, useEffect, useMemo, useRef, useState } from 'react';
import { CheckboxControlsList, CustomSelectBlock, DropDownModal } from '@marriott/mi-ui-library';

interface ControlsProps {
  code?: string;
  label: string;
  disabled?: boolean;
}

interface LegalValidatorControlsProps {
  selectedConsentControlsMap: Map<string, boolean>;
  setSelectedConsentControlsMap: Dispatch<SetStateAction<Map<string, boolean>>>;
}

const validatorCheckboxControls: ControlsProps[] = [
  { label: 'Validate Errors', code: 'validate-error', disabled: false },
  { label: 'Show Data Inspector', code: 'show-data-inspector', disabled: false },
  { label: 'Show Custom Loader', code: 'show-custom-loader', disabled: false },
  { label: 'Override Links', code: 'override-links', disabled: false },
  { label: 'Show Modal', code: 'show-modal', disabled: false },
];

export const LegalValidatorControls: FC<LegalValidatorControlsProps> = ({
  selectedConsentControlsMap,
  setSelectedConsentControlsMap,
}) => {
  const [popupOpenState, setPopupOpenState] = useState(false);
  const dropdownContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!popupOpenState) return;

    const handleClickOutside = (event: Event) => {
      const container = dropdownContainerRef.current;
      const target = event.target as Node;
      if (container && !container.contains(target)) {
        setPopupOpenState(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [popupOpenState]);

  const defaultSelected = useMemo(
    () =>
      validatorCheckboxControls.filter(control =>
        control.code ? selectedConsentControlsMap.get(control.code) === true : false
      ),
    [selectedConsentControlsMap]
  );

  const handleConsentValidatorcontrols = (selectedValues: ControlsProps[]): void => {
    const updatedConsentControls = new Map<string, boolean>();
    selectedValues.forEach(selectedValue => {
      if (selectedValue.code) {
        updatedConsentControls.set(selectedValue.code, true);
      }
    });
    setSelectedConsentControlsMap(updatedConsentControls);
  };

  const togglePopup = () => {
    setPopupOpenState(prev => !prev);
  };

  const renderPopupMenu = () => {
    return (
      <div className="legal-consent-validator-controls" style={{ textAlign: 'left', paddingTop: '1rem' }}>
        <CheckboxControlsList
          controls={validatorCheckboxControls}
          onChange={handleConsentValidatorcontrols}
          defaultSelected={defaultSelected}
          name={'consent-validator-controls'}
          title=""
          colLength={12}
        />
      </div>
    );
  };

  return (
    <div
      style={{ position: 'relative', zIndex: 1 }}
      className="col-12 col-md-6 col-lg-3 mb-2 mb-md-3 mb-lg-0"
      ref={dropdownContainerRef}
    >
      <CustomSelectBlock
        selectTitle={''}
        selectDescription={'Configuration'}
        handleClick={togglePopup}
        name={'Configuration'}
        id={'legal-consent-configuration'}
        isExpanded={popupOpenState}
        customButtonClass="t-font-weight-r t-font-m"
      />
      <div style={{ position: 'absolute' }}>
        {popupOpenState && (
          <DropDownModal
            className="legal-consent-validator-modal"
            children={renderPopupMenu()}
            applyDefaultHeight={true}
            show={popupOpenState}
            scrollDownModalCloseState={false}
          />
        )}
      </div>
    </div>
  );
};
